function FormBlock() {
    return ( 
        <>
            <div className="calendar-form container" id="apply-form">
                <div className="apply-now">
                    <h1>
                        APPLY NOW
                    </h1>
                    <div className="arrow">
                        <div className="line-full-width"></div>
                    </div>
                    <p>Choose the time when we could contact you</p>
                </div>

                <div className="iframe">
                    <iframe title="contact" src="https://calendly.com/contact-onlyglance/15min"></iframe>
                </div>
                
            </div>
        </>
     );
}

export default FormBlock;